import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Users.css';

// Component
import UserManagement from '../../../components/siteadmin/UserManagement';
import history from '../../../core/history';
import { parseRecentLimitFromUrl } from './usersRecentLimit';
import { parseDeviceFilterFromUrl } from './usersDeviceFilter';

class Users extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      searchList: '',
      recentLimit: parseRecentLimitFromUrl(),
      deviceFilter: parseDeviceFilterFromUrl(),
    };
    this.setStateVariable = this.setStateVariable.bind(this);
    this.syncStateFromUrl = this.syncStateFromUrl.bind(this);
  }

  componentDidMount() {
    // Re-sync filters when URL changes (e.g. signup notification "See All").
    if (history) {
      this.unlisten = history.listen(this.syncStateFromUrl);
    }
  }

  componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
    }
  }

  syncStateFromUrl() {
    this.setState({
      recentLimit: parseRecentLimitFromUrl(),
      deviceFilter: parseDeviceFilterFromUrl(),
      currentPage: 1,
    });
  }
  setStateVariable(variables) {
    this.setState(variables);
  }


  render() {
    const { currentPage, searchList, recentLimit, deviceFilter } = this.state;

    return (
      <UserManagement
        currentPage={currentPage}
        searchList={searchList}
        recentLimit={recentLimit}
        deviceFilter={deviceFilter}
        setStateVariable={this.setStateVariable}
      />
    );
  }
}

export default compose(
  withStyles(s)
)(Users);
